import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Episodes from "./components/Episodes";
import Hosts from "./components/Hosts";
import Team from "./components/Team";
import Sponsors from "./components/Sponsors";
import Community from "./components/Community";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Episodes />
      <Hosts />
      <Team />
      <Sponsors />
      <Community />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
